import { Epic, ofType } from 'redux-observable';
import { EpicDependencies } from '@ui/store/rootEpic';
import * as actions from '../actions';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

export const editStore: Epic<any, any, any, EpicDependencies> = (
  action$,
  store,
  { storeApi },
) =>
  action$.pipe(
    ofType(actions.EDIT_STORE_ACTIONS.REQUESTED),
    switchMap(({ payload: { values } }) =>
      storeApi.editStore(values).pipe(
        switchMap(() => {
          const { openCity } = store.value.stores;
          return of(
            actions.storesRequested(openCity),
            actions.editStoreSucceeded(),
          );
        }),
        catchError(error => of(actions.editStoreFailed(error))),
      ),
    ),
  );



// WEBPACK FOOTER //
// ./src/scenes/Stores/services/epics/editStore.ts